enum OutputTypeEnum {
    PAPER = 1,
    DRAFT = 2,
    DIGITAL_VID = 3,
    DIGITAL_REMOTE = 4,
  }

  export default OutputTypeEnum;